// 全局过滤器
import {getDateStr} from '../tools/base';

let translatDateToDay = val => {
    if (val) {
        let dateStr = getDateStr(new Date(val));
        return `${dateStr.Year}年${dateStr.Month}月${dateStr.Day}日`;
    } else {
        return val;
    }
};
let translatDateToDayPoint = val => {
    if (val) {
        let dateStr = getDateStr(new Date(val));
        return `${dateStr.Year}.${dateStr.Month}.${dateStr.Day}`;
    } else {
        return val;
    }
};
let translatDateToDayPointStr = val => {
    if (val) {
        let str = val.replace('T',' ');
        let dateStr = getDateStr(new Date(str.replace(/-/g,'/')));
        return `${dateStr.Year}.${dateStr.Month}.${dateStr.Day}`;
    } else {
        return val;
    }
};

let translatDateToSec = val => {
    if (val) {
        let dateStr = getDateStr(new Date(val));
        return `${dateStr.Year}年${dateStr.Month}月${dateStr.Day}日 ${dateStr.Hour}:${dateStr.Minutes}:${dateStr.Seconds}`;
    } else {
        return val;
    }
};
let translatDateToDayEn = val => {
    if (val) {
        let dateStr = getDateStr(new Date(val));
        return `${dateStr.Year}/${dateStr.Month}/${dateStr.Day}`;
    } else {
        return val;
    }
};
let translatDateToSecEn = val => {
    if (val) {
        let dateStr = getDateStr(new Date(val));
        return `${dateStr.Year}-${dateStr.Month}-${dateStr.Day} ${dateStr.Hour}:${dateStr.Minutes}:${dateStr.Seconds}`;
    } else {
        return val;
    }
};
let translatDateToMinEn = val => {
    if (val) {
        let dateStr = getDateStr(new Date(val));
        return `${dateStr.Year}-${dateStr.Month}-${dateStr.Day} ${dateStr.Hour}:${dateStr.Minutes}`;
    } else {
        return val;
    }
};
let translatParkState = val => {
    return val ? '启用' : '停用';
};

export {translatDateToDay,translatDateToDayPointStr,translatDateToDayPoint, translatDateToSec, translatDateToDayEn, translatDateToSecEn, translatDateToMinEn, translatParkState};


// WEBPACK FOOTER //
// ./src/util/filters/index.js